var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.certificates,
          columns: _vm.columns_certificates,
          "row-key": "id",
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          filter: _vm.filter_certificates,
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestCertificates
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter_certificates,
                    callback: function($$v) {
                      _vm.filter_certificates = $$v
                    },
                    expression: "filter_certificates"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _vm.permissions.reports
                  ? _c("q-btn", {
                      attrs: {
                        color: "secondary",
                        icon: "fas fa-download",
                        label: _vm.$t("certified_report")
                      },
                      on: {
                        click: function($event) {
                          return _vm.downloadCertificate()
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-td",
                      { key: "user_full_name", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.user_full_name) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c("q-td", { key: "user_email", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.user_email) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "result_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.result_date) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c("q-td", { key: "score", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            props.row.score ? props.row.score.toFixed(2) : ""
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "expiration_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.expiration_date) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      { key: "expired", attrs: { props: props } },
                      [
                        props.row.expired !== null
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "full-width text-center",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconExpire(props.row.expired),
                                  color: _vm.getColorExpire(props.row.expired)
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.getTextExpire(props.row.expired)
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      {
                        key: "status",
                        attrs: { props: props, "auto-width": "" }
                      },
                      [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-width text-center",
                            attrs: {
                              small: "",
                              icon: _vm.getIconStatus(props.row.status),
                              color: _vm.getColorStatus(props.row.status)
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(_vm.getTextStatus(props.row.status))
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "user_branches", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              color: "primary",
                              "text-color": "white",
                              label: props.row.user_branches
                                ? props.row.user_branches.length
                                : 0,
                              "no-ripple": ""
                            }
                          },
                          [
                            _c("q-tooltip", [
                              props.row.user_branches &&
                              props.row.user_branches.length > 0
                                ? _c(
                                    "p",
                                    { staticClass: "tooltip q-mb-sm" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("branches")) +
                                          ":\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _vm._l(props.row.user_branches, function(
                                        branch,
                                        index
                                      ) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(branch) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          props.row.user_branches.length - 1 >
                                          index
                                            ? _c("span", [
                                                _vm._v(",\n\t\t\t\t\t\t\t\t\t")
                                              ])
                                            : _vm._e()
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }